/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2023-05-08 13:23:38
 */
 
 import Api from "src/util/api";
 import {PageDo, Result, ResultPageDo, Integer} from "src/types/base";

 export declare namespace FeedbackOpinionDOI {
 
     export interface RowDataI {
         create_time: string
         user_name: string
         mobile: string
         id: number
         feedback_content:string
     }
 
     export interface QueryRowDataParamsI extends PageDo {
        keyword?: string
     }
 
 }
 export default class FeedbackOpinionApi {
     /**
      * 查询列表
      * @param {FeedbackOpinionDOI.QueryRowDataParamsI} params
      * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
      */
    static async searchList(params: FeedbackOpinionDOI.QueryRowDataParamsI):Promise<ResultPageDo<FeedbackOpinionDOI.RowDataI[]>> {
        return Api.post('/auth_login/opinion/query', params)
    }
 }